import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor(private http: HttpClient) { }

  saveComanies(id: any, payload: any) {

    
    if (id) {
      return this.http.patch(urls.API_URL + urls.COMPANIES + `/${id}`, payload)
      .pipe(catchError(errorHandl));
    }
    return this.http.post(urls.API_URL + urls.COMPANIES, payload)
    .pipe(catchError(errorHandl));
   
  }

  getCompanies(queryParams: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.COMPANIES, { params })
      .pipe(catchError(errorHandl));
  }

  getCompanyById(id: any) {
    return this.http.get(urls.API_URL + urls.COMPANIES + `/${id}`)
      .pipe(catchError(errorHandl));
  }

}

